import React, { Component } from 'react';
import { APP_URL_API } from '../../../../setup/configs'
import axios from 'axios';
import Years from '../../../reports/Years';

/*

Reports (indberetninger) renders an interface for uploading annual reports and donations, but also allows for submitting member count.

Admins can delete files and unlock membercount

Congregation owner can choose to attach annual report from community
*/

class Reports extends Component {
    constructor(props) {
        super(props)

        this.state = {
          years: [],
        }
    }

    componentDidMount() {
        const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const url = APP_URL_API + 'years';

        this.serverRequest =
            axios
                .get(url, {headers: config})
                .then(function(result) {
                    this.setState({
                        years: result.data.data.reverse()
                    });
                }.bind(this))
    }

    render() {
        return(
            <Years years={this.state.years}
                updateUnlockedStatus={this.props.updateUnlockedStatus}
                memberships={this.props.organization.memberships}
                organizationType={this.props.organization.type}
                organizationId={this.props.organization.id}
                approvedAt={this.props.organization.approved_at}
                onHandleAddMembersCount={this.props.onHandleAddMembersCount}
                onHandlePrepareFileForUpload={this.props.onHandlePrepareFileForUpload}
                deleteDocumentFromServer={this.props.deleteDocumentFromServer}
                formDataUpdated={this.props.formDataUpdated}
                onHandleFileDelete={this.props.onHandleFileDelete}
                annualReports={this.props.organization.annualReports}
                annualReportsParent={this.props.organization.parent.annualReports}
                donationsParent={this.props.organization.parent.donations}
                annualReportsWaitingForApproval={this.props.organization.annualReportsWaitingForApproval}
                donationsWaitingForApproval={this.props.organization.donationsWaitingForApproval}
                donations={this.props.organization.donations}
                file={this.props.file}
                file2={this.props.file2}
                user={this.props.user} />
            );
    }
}

export default Reports;


// WEBPACK FOOTER //
// ./src/modules/admin/organization/sections/Reports.js